import { Directive, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CommonService } from '../../core/services/common.service';
import { TrackUsageModel } from '../../models/dashboard.model';
import { AuthService } from '../../core/services/auth.service';
import { debounceTime, fromEvent, map, merge, Subscription } from 'rxjs';

@Directive({
  selector: '[appEventTracking]',
  standalone: true,
})
export class EventTrackingDirective implements OnDestroy {
  private subscription: Subscription;
  constructor(
    private title: Title,
    private commonService: CommonService,
    private userService: AuthService
  ) {
    const inputEvents$ = fromEvent(document, 'input').pipe(
      debounceTime(300),
      map((event: Event) => ({ eventType: 'input', target: event.target as HTMLElement, event: event }))
    );

    const clickEvents$ = fromEvent(document, 'click').pipe(map((event: Event) => ({ eventType: 'click', target: event.target as HTMLElement, event: event })));

    // Merge both event streams
    this.subscription = merge(inputEvents$, clickEvents$).subscribe(({ eventType, target, event }) => {
      if (eventType === 'input') {
        this.trackTextEvent(target, event);
      } else if (eventType === 'click') {
        this.trackClickEvent(target, event);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private isInteractiveElement(element: HTMLElement): boolean {
    const interactiveTags = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'IMG'];
    return interactiveTags.includes(element.tagName);
  }

  private trackTextEvent(clickedElement: HTMLElement, event: any) {
    const currentTitle = this.title.getTitle();
    let userAction = '';

    switch (clickedElement.tagName) {
      case 'TEXTAREA':
      case 'INPUT':
        {
          if ((clickedElement instanceof HTMLTextAreaElement || clickedElement instanceof HTMLInputElement) && clickedElement.type !== 'button') {
            userAction = `"[${event.target.value}]" of ${clickedElement.tagName} Entered`;
          }
        }
        break;
      default: {
        userAction = `${clickedElement.tagName} Clicked`;
      }
    }
    if (userAction != '' && currentTitle != '') {
      this.logUsageStats(currentTitle, userAction!);
    }
    
  }

  private trackClickEvent(clickedElement: HTMLElement, event: any) {
    const currentTitle = this.title.getTitle();
    let userAction = '';
    console.log(currentTitle);
    console.log('Clicked on:', clickedElement);

    switch (clickedElement.tagName) {
      case 'SELECT':
        {
          userAction = `"[${event.target.value}]" of ${clickedElement.tagName} Clicked`;
        }
        break;
      case 'TEXTAREA':
      case 'INPUT':
        {
          if (clickedElement instanceof HTMLInputElement && clickedElement.type === 'button') {
            userAction = `"[${clickedElement.textContent}]" ${clickedElement.tagName} Clicked`;
          }
        }
        break;
      case 'A':
        {
          userAction = `"[${(clickedElement as HTMLAnchorElement).href}]" ${clickedElement.tagName} Clicked`;
        }
        break;
      case 'BUTTON':
        {
          userAction = `"[${clickedElement.textContent}]" ${clickedElement.tagName} Clicked`;
        }
        break;
      case 'IMG':
        {
          userAction = `"[${(clickedElement as HTMLImageElement).src}]" ${clickedElement.tagName} Clicked`;
        }
        break;
      default: {
        userAction = `${clickedElement.tagName} Clicked`;
      }
    }
    if (userAction != '' && currentTitle != '') {
      this.logUsageStats(currentTitle, userAction!);
    }
  }

  private logUsageStats(currentTitle: string, userAction: string, customInfo1: string = '', customInfo2: string = '') {
    
    const request: TrackUsageModel = {
      emailAddress: this.userService.$authState()?.username!,
      moduleId: 0,
      page: currentTitle,
      userAction: userAction,
      actionTime: new Date(),
      IsAdmin: this.userService.$isAdmin(),
      memberFirm: '',
      customInfo1: customInfo1,
      customInfo2: customInfo2,
    };
    this.commonService.trackUsageStatusBase(request).subscribe();
  }
}
